function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('keypress', this.onKeyPress.bind(this));
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    // this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onKeyPress(event) {
    if (!/\d/.test(event.key)) {
      event.preventDefault();
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    const isDisabled = event.target.className.includes('disabled');

    if (isDisabled) {
      return;
    }

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    const buttonsWrapper = this.closest('product-info');
    const currentButton = buttonsWrapper?.querySelector('button[type="submit"].active');
    const currentButtonSpan = currentButton?.querySelector('span');
    const inventory = currentButton?.getAttribute('data-inventory');
    const message = currentButton?.getAttribute('data-message');
    if (currentButton && message && value > +inventory) {
      currentButtonSpan.textContent = message;
    } else if (currentButton && message) {
      currentButtonSpan.textContent = "Add to Cart";
    }
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    // this.querySelectorAll(
    //   'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    // ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    this.headerTabsSection = document.querySelector('.header-tabs-section');
    this.querySelector('button[type="reset"]')?.addEventListener('click', (event) => {
      this.querySelector('details summary').click();
    });
  }

  openMenuDrawer(summaryElement) {
    if ($('.menu-drawer__promo-wrapper').not('.slick-initialized').length) {
      $('.menu-drawer__promo-wrapper').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        autoplay: true,
        arrows: true,
        fade: true,
        cssEase: 'linear',
        prevArrow: `
            <div class="slick-prev">
              <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
              </svg>
            </div>`,
        nextArrow: `
            <div class="slick-next">
              <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
              </svg>
            </div>`
      });
    }
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);

    // Hide header tabs section when menu opens
    this.hideHeaderTabsSection();
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);

    // Show header tabs section when menu closes
    this.showHeaderTabsSection();
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };

  // Methods to handle header tabs section visibility
  hideHeaderTabsSection() {
    if (this.headerTabsSection) {
      this.headerTabsSection.style.display = 'none';
    }
  }

  showHeaderTabsSection() {
    if (this.headerTabsSection) {
      this.headerTabsSection.style.display = '';
    }
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    // if (this.classList.contains('media-modal')) {
    //   this.addEventListener('pointerup', (event) => {
    //     if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
    //   });
    // } else {
    //   this.addEventListener('click', (event) => {
    //     if (event.target === this) this.hide();
    //   });
    // }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      // if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    // Initialize options and current variant
    this.updateOptions();
    this.updateMasterId();

    // Set the initial data-variant on the product-form
    if (this.currentVariant) {
      const productForm = document.querySelector('product-form');
      if (productForm) {
        productForm.setAttribute('data-variant', this.currentVariant.id);
      }
    }

    this.updatePromolines();
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.updateComingSoon(event);
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.updatePromolines();

    const dataSection = this.closest('product-info').getAttribute('data-section');
    const isQuickAdd = dataSection.includes('quickadd');

    if (!isQuickAdd) {
      this.updateMatchYourBed();
      this.setBundledProduct();
    }

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.sendCustomEvent();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.changeButton();
    }
  }

  sendCustomEvent() {
    const variantChangeEvent = new CustomEvent('variantChanged', {
      detail: { variantId: this.currentVariant?.id },
      bubbles: true,
      cancelable: true
    });
    document.dispatchEvent(variantChangeEvent);
  }

  updateComingSoon({ target }) {
    const variantSelects = target.closest('variant-selects');
    if (variantSelects && this.currentVariant?.id) {
      variantSelects.setAttribute('data-variant', this.currentVariant.id);
      if (window.comingSoonVariants.includes(this.currentVariant.id.toString())) {
        variantSelects?.setAttribute('data-coming-soon', true);
      } else {
        variantSelects?.setAttribute('data-coming-soon', false);
      }
    }
  }

  updatePromolines() {
    const selectedVariant = this.currentVariant?.id.toString() || this.getAttribute('data-variant')
    if (!selectedVariant) return;

    const currentVariantId = selectedVariant;
    const allPromolines = document.querySelectorAll('[data-promoline-type]');

    allPromolines.forEach(promoline => {
      const type = promoline.getAttribute('data-promoline-type');

      if (type === 'variant') {
        // For variant-specific promolines, check if current variant is in the list
        const variantIds = promoline.getAttribute('data-promoline-variants');
        if (variantIds && variantIds.split(';').includes(currentVariantId)) {
          promoline.style.display = 'flex';
        } else {
          promoline.style.display = 'none';
        }
      } else if (type === 'product') {
        // Show product-level promolines only if no variant-specific ones are active
        const hasActiveVariantPromoline = Array.from(allPromolines).some(pl => {
          if (pl.getAttribute('data-promoline-type') !== 'variant') return false;
          const variantIds = pl.getAttribute('data-promoline-variants');
          return variantIds && variantIds.split(',').includes(currentVariantId) && pl.style.display !== 'none';
        });

        if (hasActiveVariantPromoline) {
          promoline.style.display = 'none';
        } else {
          promoline.style.display = 'flex';
        }
      } else if (type === 'collection') {
        // Show collection-level promolines only if no variant or product ones are active
        const hasActiveSpecificPromoline = Array.from(allPromolines).some(pl => {
          const plType = pl.getAttribute('data-promoline-type');
          if (plType === 'variant') {
            const variantIds = pl.getAttribute('data-promoline-variants');
            return variantIds && variantIds.split(',').includes(currentVariantId) && pl.style.display !== 'none';
          } else if (plType === 'product') {
            return pl.style.display !== 'none';
          }
          return false;
        });

        if (hasActiveSpecificPromoline) {
          promoline.style.display = 'none';
        } else {
          promoline.style.display = 'flex';
        }
      }
    });
  }

  changeButton() {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    const addButtons = productForm.querySelectorAll('[name="add"][data-preorder="false"]');
    if (addButtons.length > 0) {
      addButtons.forEach(button => {
        if (button.getAttribute('data-variant') == this.currentVariant.id) {
          button.classList.add('active');
        } else {
          button.classList.remove('active');
        }
      })
    }

    // Update the product-form data-variant attribute directly
    const mainForm = document.querySelector('product-form');
    if (mainForm) {
      mainForm.setAttribute('data-variant', this.currentVariant.id);
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;
    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) {
        const sizeMap = { 'small': 'S', 'medium': 'M', 'large': 'L' };
        selectedSwatchValue.innerHTML = sizeMap[value.toLowerCase()] || value;
      }
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  updateMedia(html) {
    const quickAddSectionId = this.dataset.section.includes('quickadd') ? this.dataset.section.replace('quickadd-', '') : this.dataset.section;
    const mediaGallerySource = document.querySelector(`[id^="MediaGallery-${this.dataset.section}"] ul`);
    const mediaGalleryDestination = html.querySelector(`[id^="MediaGallery-${quickAddSectionId}"] ul`);

    const refreshSourceData = () => {
      const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
      const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
      const sourceMap = new Map(mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }]));
      return [mediaGallerySourceItems, sourceSet, sourceMap];
    };

    if (mediaGallerySource && mediaGalleryDestination) {
      let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
      const mediaGalleryDestinationItems = Array.from(mediaGalleryDestination.querySelectorAll('li[data-media-id]'));
      const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
      let shouldRefresh = false;

      // add items from new data not present in DOM
      for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
        if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
          mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
          shouldRefresh = true;
        }
      }

      // remove items from DOM not present in new data
      for (let i = 0; i < mediaGallerySourceItems.length; i++) {
        if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
          mediaGallerySourceItems[i].remove();
          shouldRefresh = true;
        }
      }

      // refresh
      if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

      // if media galleries don't match, sort to match new data order
      mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
        const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

        if (sourceData && sourceData.index !== destinationIndex) {
          mediaGallerySource.insertBefore(
            sourceData.item,
            mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
          );

          // refresh source now that it has been modified
          [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
        }
      });
    }

    if (this.currentVariant.featured_media) {
      document
        .querySelector(`[id^="MediaGallery-${this.dataset.section}"]`)
        ?.setActiveMedia?.(`${this.dataset.section}-${this.currentVariant.featured_media.id}`);
    }

    // update media modal
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newModalContent = html.querySelector(`product-modal`);
    if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        this.updateMedia(html);

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.querySelector(`#ProductSubmitButton-${sectionId}[data-variant="${requestedVariantId}"`);
        if (addButtonUpdated) {
          this.toggleAddButton(
            addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
            window.variantStrings.soldOut
          );
        }

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateMatchYourBed() {
    const matchDivs = document.querySelectorAll('.productPage__matchBed-grid-wrapper');
    const currentDiv = Array.from(matchDivs).filter(div => div.getAttribute('data-variant') == this.currentVariant.id);

    matchDivs.forEach(div => div.classList.remove("active"));

    if (currentDiv.length === 0) {
      return;
    }

    currentDiv.forEach(div => div.classList.add("active"));

  }

  setBundledProduct() {
    const essentialVariants = document.querySelectorAll('.essentials.variant');
    const currentDiv = Array.from(essentialVariants).filter(div => div.getAttribute('data-variant') == this.currentVariant.id);
    const paymentOptionInput = document.getElementById('payment-plan');
    const bundledVariant = currentDiv[0]?.getAttribute('data-bundled-variant');
    const currentDivTitle = currentDiv[0]?.querySelector('.essentials_col2 h3')?.textContent;
    const currentDivImageSrc = currentDiv[0]?.querySelector('.essentials_col1 img')?.getAttribute('src');
    const giftBundledVariant = document.querySelector('.gift-list.bundled-variant');

    essentialVariants.forEach(div => div.classList.remove("active"));

    if (currentDiv.length === 0) {
      return;
    }

    if (currentDivTitle) {
      const giftBundledVariantTitle = giftBundledVariant?.querySelector('.gift-text h3');
      const giftBundledVariantImage = giftBundledVariant?.querySelector('.gift-img');
      giftBundledVariantTitle ? giftBundledVariantTitle.textContent = currentDivTitle : '';
      giftBundledVariantImage ? giftBundledVariantImage.setAttribute('src', currentDivImageSrc) : '';
    }
    currentDiv.forEach(div => div.classList.add("active"));
    paymentOptionInput.setAttribute('data-bundled-variant', bundledVariant)
  }

}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

//Header Transparency:
// Transparent header height management
function updateHeaderHeight() {
  const header = document.querySelector('.section-header .header');
  if (header) {
    const headerHeight = header.offsetHeight;
    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
  }
}

// Add body class for transparent header
function initTransparentHeader() {
  const transparentHeader = document.querySelector('.header-wrapper.header-transparent');
  if (transparentHeader) {
    document.body.classList.add('transparent-header-active');
    updateHeaderHeight();

    // Update on resize
    window.addEventListener('resize', updateHeaderHeight);
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTransparentHeader);
} else {
  initTransparentHeader();
}
// Mega menu hover with manual animation
// document.addEventListener('DOMContentLoaded', function() {
//   const headerMenus = document.querySelectorAll('.header__inline-menu header-menu');

//   headerMenus.forEach(headerMenu => {
//     const details = headerMenu.querySelector('details');
//     const summary = headerMenu.querySelector('summary');
//     const content = headerMenu.querySelector('.mega-menu__content');

//     if (!details || !summary || !content) return;

//     let isAnimating = false;

//     // Prevent default click behavior
//     summary.addEventListener('click', function(e) {
//       e.preventDefault();
//       e.stopPropagation();
//       return false;
//     });

//     // Hover to show
//     headerMenu.addEventListener('mouseenter', function() {
//       if (isAnimating) return;
//       isAnimating = true;

//       // Open details first
//       details.setAttribute('open', '');
//       summary.setAttribute('aria-expanded', 'true');

//       // Force initial state
//       content.style.opacity = '0';
//       content.style.transform = 'translateY(-10px)';
//       content.style.transition = 'opacity 0.3s ease-out, transform 0.3s ease-out';

//       // Animate in
//       requestAnimationFrame(() => {
//         content.style.opacity = '1';
//         content.style.transform = 'translateY(0)';
//         setTimeout(() => { isAnimating = false; }, 300);
//       });
//     });

//     // Hover to hide
//     headerMenu.addEventListener('mouseleave', function() {
//       if (isAnimating) return;
//       isAnimating = true;

//       // Animate out
//       content.style.opacity = '0';
//       content.style.transform = 'translateY(-10px)';

//       // Close details after animation
//       setTimeout(() => {
//         if (!headerMenu.matches(':hover')) {
//           details.removeAttribute('open');
//           summary.setAttribute('aria-expanded', 'false');
//         }
//         isAnimating = false;
//       }, 300);
//     });
//   });
// });
class ZoomContainer extends HTMLElement {
  constructor() {
    super();
    this.isZoomed = false;
    this.scale = 1;
    this.translateX = 0;
    this.translateY = 0;

    // Touch state management
    this.touchState = {
      isPinching: false,
      isDragging: false,
      startDistance: 0,
      startScale: 1,
      startTranslateX: 0,
      startTranslateY: 0,
      pinchCenter: { x: 0, y: 0 },
      singleTouchStart: { x: 0, y: 0 },
      lastInteractionTime: 0,
      interactionType: null, // 'pinch', 'drag', 'tap', or null
      pinchThreshold: 10, // minimum distance change to register as pinch
      dragThreshold: 5, // minimum movement to register as drag
      tapDebounceTime: 100 // ms to wait after pinch before allowing tap
    };

    this.mouseTrackingEnabled = true;

    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchMove = this.handleTouchMove.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);
    this.handleClick = this.handleClick.bind(this);

    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  connectedCallback() {
    this.style.overflow = 'hidden';
    this.style.position = 'relative';
    this.style.width = '100%';
    this.style.height = '100%';
    this.style.cursor = 'zoom-in';

    const img = this.querySelector('img');
    if (img) {
      img.style.setProperty('transition', 'transform 0.3s ease', 'important');
      img.style.setProperty('transform-origin', 'center center', 'important');
      img.style.setProperty('user-select', 'none', 'important');
      img.style.setProperty('touch-action', 'none', 'important');
      img.draggable = false;

      if (img.complete) {
      } else {
        img.addEventListener('load', () => {
        });
      }
    } else {
    }

    this.addEventListener('touchstart', this.handleTouchStart, { passive: false });
    this.addEventListener('touchmove', this.handleTouchMove, { passive: false });
    this.addEventListener('touchend', this.handleTouchEnd, { passive: false });
    this.addEventListener('click', this.handleClick);

    this.addEventListener('mousedown', this.handleMouseDown);
    this.addEventListener('mousemove', this.handleMouseMove);
    this.addEventListener('mouseup', this.handleMouseUp);
    this.addEventListener('mouseleave', this.handleMouseLeave);
  }

  disconnectedCallback() {
    this.removeEventListener('touchstart', this.handleTouchStart);
    this.removeEventListener('touchmove', this.handleTouchMove);
    this.removeEventListener('touchend', this.handleTouchEnd);
    this.removeEventListener('click', this.handleClick);
    this.removeEventListener('mousedown', this.handleMouseDown);
    this.removeEventListener('mousemove', this.handleMouseMove);
    this.removeEventListener('mouseup', this.handleMouseUp);
    this.removeEventListener('mouseleave', this.handleMouseLeave);
  }

  getDistance(touches) {
    const dx = touches[0].clientX - touches[1].clientX;
    const dy = touches[0].clientY - touches[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  getCenterPoint(touches) {
    return {
      x: (touches[0].clientX + touches[1].clientX) / 2,
      y: (touches[0].clientY + touches[1].clientY) / 2
    };
  }

  resetTouchState() {
    this.touchState.isPinching = false;
    this.touchState.isDragging = false;
    this.touchState.interactionType = null;
    this.touchState.lastInteractionTime = Date.now();
  }

  handleMouseDown(e) {
    if (!this.isZoomed && e.button === 0) {
      return;
    }
  }

  handleMouseMove(e) {
    if (this.isZoomed) {
      e.preventDefault();

      const rect = this.getBoundingClientRect();
      const mouseX = e.clientX - rect.left;
      const mouseY = e.clientY - rect.top;

      const containerCenterX = rect.width / 2;
      const containerCenterY = rect.height / 2;

      const maxTranslateX = (this.querySelector('img').offsetWidth * (this.scale - 1)) / 2;
      const maxTranslateY = (this.querySelector('img').offsetHeight * (this.scale - 1)) / 2;

      const translateFactorX = (mouseX - containerCenterX) / (containerCenterX);
      const translateFactorY = (mouseY - containerCenterY) / (containerCenterY);

      this.translateX = -translateFactorX * maxTranslateX * 0.8;
      this.translateY = -translateFactorY * maxTranslateY * 0.8;

      this.updateTransform();
    }
  }

  handleMouseUp(e) {
  }

  handleMouseLeave(e) {
    if (this.isZoomed) {
      this.translateX = 0;
      this.translateY = 0;
      this.updateTransform();
    }
  }

  handleTouchStart(e) {
    const touches = e.touches;
    const now = Date.now();

    if (touches.length === 1) {
      // Single touch - potential drag or tap
      this.touchState.singleTouchStart = {
        x: touches[0].clientX,
        y: touches[0].clientY
      };
      this.touchState.startTranslateX = this.translateX;
      this.touchState.startTranslateY = this.translateY;
      this.touchState.isDragging = false;

      // Don't set interaction type yet - wait for movement

    } else if (touches.length === 2) {
      // Two touches - pinch gesture
      e.preventDefault();

      this.touchState.isPinching = true;
      this.touchState.interactionType = 'pinch';
      this.touchState.startDistance = this.getDistance(touches);
      this.touchState.startScale = this.scale;

      const center = this.getCenterPoint(touches);
      const rect = this.getBoundingClientRect();
      this.touchState.pinchCenter = {
        x: center.x - rect.left,
        y: center.y - rect.top
      };
    }
  }

  handleTouchMove(e) {
    const touches = e.touches;

    if (touches.length === 1 && this.isZoomed && !this.touchState.isPinching) {
      // Single touch drag
      const deltaX = touches[0].clientX - this.touchState.singleTouchStart.x;
      const deltaY = touches[0].clientY - this.touchState.singleTouchStart.y;

      const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);

      if (distance > this.touchState.dragThreshold) {
        if (!this.touchState.isDragging) {
          this.touchState.isDragging = true;
          this.touchState.interactionType = 'drag';
        }

        e.preventDefault();
        this.translateX = this.touchState.startTranslateX + deltaX;
        this.translateY = this.touchState.startTranslateY + deltaY;
        this.updateTransform();
      }

    } else if (touches.length === 2 && this.touchState.isPinching) {
      // Two touch pinch
      e.preventDefault();

      const currentDistance = this.getDistance(touches);
      const distanceChange = Math.abs(currentDistance - this.touchState.startDistance);

      // Only start scaling if we've moved beyond threshold
      if (distanceChange > this.touchState.pinchThreshold) {
        const scaleChange = currentDistance / this.touchState.startDistance;
        let newScale = this.touchState.startScale * scaleChange;

        // Clamp scale between 1 and 4
        newScale = Math.max(1, Math.min(4, newScale));

        this.scale = newScale;

        // Calculate translation to keep pinch center point fixed
        const containerCenterX = this.offsetWidth / 2;
        const containerCenterY = this.offsetHeight / 2;

        const pinchOffsetX = this.touchState.pinchCenter.x - containerCenterX;
        const pinchOffsetY = this.touchState.pinchCenter.y - containerCenterY;

        this.translateX = -pinchOffsetX * (this.scale - 1);
        this.translateY = -pinchOffsetY * (this.scale - 1);

        // Update zoom state
        this.isZoomed = this.scale > 1;
        this.style.cursor = this.isZoomed ? 'zoom-out' : 'zoom-in';

        this.updateTransform();
      }
    }
  }

  handleTouchEnd(e) {
    const remainingTouches = e.touches.length;
    const now = Date.now();

    if (this.touchState.isPinching && remainingTouches < 2) {
      // Pinch gesture ended
      if (this.scale <= 1.1) {
        // If barely zoomed, reset to 1
        this.resetZoom();
      }

      this.resetTouchState();
      return;
    }

    if (remainingTouches === 0) {
      // All touches ended
      const timeSinceLastInteraction = now - this.touchState.lastInteractionTime;

      if (this.touchState.interactionType === 'pinch') {
        // Just finished pinching - don't allow tap for a moment
        this.resetTouchState();
        return;
      }

      if (!this.touchState.isDragging &&
        this.touchState.interactionType !== 'pinch' &&
        timeSinceLastInteraction > this.touchState.tapDebounceTime) {
        // This was a tap
        this.handleTap(e);
      }

      this.resetTouchState();
    }
  }

  handleClick(e) {
    // Only handle mouse clicks (not touch events)
    if (e.pointerType === 'mouse' || !('ontouchstart' in window)) {
      const timeSinceLastInteraction = Date.now() - this.touchState.lastInteractionTime;
      if (timeSinceLastInteraction > this.touchState.tapDebounceTime) {
        this.handleTap(e);
      }
    }
  }

  handleTap(e) {
    if (!this.isZoomed) {
      this.zoomToPoint(e);
    } else {
      this.resetZoom();
    }
  }

  zoomToPoint(e) {
    const img = this.querySelector('img');
    if (!img) return;

    const rect = this.getBoundingClientRect();
    const tapX = (e.clientX || e.changedTouches[0].clientX) - rect.left;
    const tapY = (e.clientY || e.changedTouches[0].clientY) - rect.top;

    const containerHeight = this.offsetHeight;
    const imgHeight = img.naturalHeight;
    const imgWidth = img.naturalWidth;

    if (imgHeight && containerHeight) {
      this.scale = containerHeight / (imgHeight * (img.offsetWidth / imgWidth));
      this.scale = Math.max(this.scale, 3);
    } else {
      this.scale = 2;
    }

    const containerCenterX = rect.width / 2;
    const containerCenterY = rect.height / 2;

    const offsetX = (tapX - containerCenterX) * (this.scale - 1);
    const offsetY = (tapY - containerCenterY) * (this.scale - 1);

    this.translateX = -offsetX;
    this.translateY = -offsetY;

    this.isZoomed = true;
    this.style.cursor = 'zoom-out';

    this.updateTransform();
  }

  zoomToFit() {
    const img = this.querySelector('img');
    if (!img) return;

    const containerHeight = this.offsetHeight;
    const imgHeight = img.naturalHeight;
    const imgWidth = img.naturalWidth;

    if (imgHeight && containerHeight) {
      this.scale = containerHeight / (imgHeight * (img.offsetWidth / imgWidth));
      this.scale = Math.max(this.scale, 3);
    } else {
      this.scale = 2;
    }

    this.translateX = 0;
    this.translateY = 0;
    this.isZoomed = true;
    this.style.cursor = 'zoom-out';

    this.updateTransform();
  }

  resetZoom() {
    this.scale = 1;
    this.translateX = 0;
    this.translateY = 0;
    this.isZoomed = false;
    this.style.cursor = 'zoom-in';

    this.updateTransform();
  }

  updateTransform() {
    const img = this.querySelector('img');
    if (!img) {
      return;
    }

    if (this.scale > 1) {
      const maxTranslateX = (img.offsetWidth * (this.scale - 1)) / 2;
      const maxTranslateY = (img.offsetHeight * (this.scale - 1)) / 2;

      this.translateX = Math.max(-maxTranslateX, Math.min(maxTranslateX, this.translateX));
      this.translateY = Math.max(-maxTranslateY, Math.min(maxTranslateY, this.translateY));
    }

    const transformString = `scale(${this.scale}) translate(${this.translateX / this.scale}px, ${this.translateY / this.scale}px)`;

    // Only add transition if we're not in the middle of a pinch gesture
    if (!this.touchState.isPinching) {
      img.style.setProperty('transition', 'transform 0.3s ease', 'important');
    } else {
      img.style.setProperty('transition', 'none', 'important');
    }

    img.style.setProperty('transform', transformString, 'important');
  }
}

customElements.define('zoom-container', ZoomContainer);

const style = document.createElement('style');
style.textContent = `
  zoom-container {
    overflow: hidden !important;
    position: relative !important;
    width: 100% !important;
    height: 100% !important;
  }
  
  zoom-container img {
    width: 100% !important;
    height: auto !important;
    user-select: none !important;
    touch-action: none !important;
    transform-origin: center center !important;
    max-width: none !important;
    max-height: none !important;
  }
  
  zoom-container:not(.zoomed) {
    cursor: zoom-in !important;
  }
  
  zoom-container.zoomed {
    cursor: zoom-out !important;
  }
`;
document.head.appendChild(style);


class SlidingModal extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
    this.setupModal();
  }

  setupModal() {
    this.backdrop = document.createElement('div');
    this.backdrop.style.cssText = `
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: rgba(0, 0, 0, 0.5);
                    z-index: 9998;
                    opacity: 0;
                    visibility: hidden;
                    transition: opacity 0.3s ease, visibility 0.3s ease;
                `;

    this.modalContainer = document.createElement('div');
    this.modalContainer.style.cssText = `
                    position: fixed;
                    z-index: 9999;
                    background: white;
                    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
                    transition: transform 0.3s ease;
                    padding: 24px;
                `;

    this.updateStyles();

    while (this.firstChild) {
      this.modalContainer.appendChild(this.firstChild);
    }

    // Bind accent buttons to close the modal
    this.bindAccentButtons();

    document.body.appendChild(this.backdrop);
    document.body.appendChild(this.modalContainer);

    this.backdrop.addEventListener('click', () => this.close());
    window.addEventListener('resize', () => this.updateStyles());
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.close();
      }
    });
  }

  bindAccentButtons() {
    const accentButtons = this.modalContainer.querySelectorAll('button.accent-btn:not(.calculate)');
    accentButtons.forEach(button => {
      button.addEventListener('click', () => this.close());
    });
  }

  updateStyles() {
    const isDesktop = window.innerWidth >= 1024;

    if (isDesktop) {
      this.modalContainer.style.cssText = `
                        position: fixed;
                        top: 48px;
                        right: 40px;
                        bottom: 48px;
                        width: 440px;
                        background: white;
                        box-shadow: -4px 0 32px rgba(0, 0, 0, 0.1);
                        z-index: 9999;
                        overflow-y: auto;
                        transition: transform 0.3s ease;
                        transform: translateX(${this.isOpen ? '0' : 'calc(100% + 40px)'});
                        padding: 24px;
                        border-radius: 16px;
                    `;
    } else {
      this.modalContainer.style.cssText = `
                        position: fixed;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        width: 100%;
                        max-height: 90vh;
                        background: white;
                        box-shadow: 0 -4px 32px rgba(0, 0, 0, 0.1);
                        z-index: 9999;
                        overflow-y: auto;
                        border-radius: 16px 16px 0 0;
                        transition: transform 0.3s ease;
                        transform: translateY(${this.isOpen ? '0' : '100%'});
                        padding: 20px;
                    `;
    }
  }

  open() {
    if (this.isOpen) return;

    this.isOpen = true;
    document.body.style.overflow = 'hidden';

    this.backdrop.style.visibility = 'visible';
    this.backdrop.style.opacity = '1';

    this.updateStyles();

    this.dispatchEvent(new CustomEvent('modal-opened'));
  }

  close() {
    if (!this.isOpen) return;

    this.isOpen = false;
    document.body.style.overflow = '';

    this.backdrop.style.opacity = '0';
    this.backdrop.style.visibility = 'hidden';

    this.updateStyles();

    this.dispatchEvent(new CustomEvent('modal-closed'));
  }

  toggle() {
    this.isOpen ? this.close() : this.open();
  }

  disconnectedCallback() {
    try {
      if (this.backdrop) {
        document.body.removeChild(this.backdrop);
      }
    } catch (e) {
      // Element already removed or not a child
    }

    try {
      if (this.modalContainer) {
        document.body.removeChild(this.modalContainer);
      }
    } catch (e) {
      // Element already removed or not a child
    }

    document.body.style.overflow = '';
  }
}

customElements.define('sliding-modal', SlidingModal);

const zoomContainerStyle = document.createElement('style');
zoomContainerStyle.textContent = `
  zoom-container {
    overflow: hidden !important;
    position: relative !important;
    width: 100% !important;
    height: 100% !important;
  }
  
  zoom-container img {
    width: 100% !important;
    height: auto !important;
    user-select: none !important;
    touch-action: none !important;
    transform-origin: center center !important;
    max-width: none !important;
    max-height: none !important;
  }
  
  zoom-container:not(.zoomed) {
    cursor: zoom-in !important;
  }
  
  zoom-container.zoomed {
    cursor: zoom-out !important;
  }
`;
document.head.appendChild(zoomContainerStyle);

class CustomAccordion extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
  }

  connectedCallback() {
    const title = this.getAttribute('title') || 'Accordion';
    const shouldBeOpen = this.hasAttribute('open');

    // Store the original content
    const originalContent = this.innerHTML;

    this.innerHTML = `
                    <div class="accordion-container">
                        <h3 class="accordion-heading">
                            <button class="accordion-header" aria-expanded="${shouldBeOpen}">
                                <span class="accordion-title">${title}</span>
                                <svg class="accordion-arrow" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <polyline points="6,9 12,15 18,9"></polyline>
                                </svg>
                            </button>
                        </h3>
                        <div class="accordion-content${shouldBeOpen ? ' open' : ''}">
                            <div class="accordion-inner">
                                ${originalContent}
                            </div>
                        </div>
                    </div>
                `;

    this.setupStyles();
    this.setupEventListeners();
    
    // Set initial state
    if (shouldBeOpen) {
      this.isOpen = true;
      const content = this.querySelector('.accordion-content');
      const inner = this.querySelector('.accordion-inner');
      content.style.maxHeight = 'none';

      // Watch for async content (e.g. Tolstoy) loading and expanding the inner height
      const ro = new ResizeObserver(() => {
        if (this.isOpen) {
          content.style.maxHeight = (inner.scrollHeight + 16) + 'px';
        }
      });
      ro.observe(inner);
      this._resizeObserver = ro;
    }
  }

  disconnectedCallback() {
    if (this._resizeObserver) {
      this._resizeObserver.disconnect();
    }
  }

  setupStyles() {
    if (!document.getElementById('accordion-styles')) {
      const style = document.createElement('style');
      style.id = 'accordion-styles';
      style.textContent = `
                        custom-accordion {
                            display: block;
                            width: 100%;
                            border-bottom: 1px solid #e5e5e5;
                        }

                        custom-accordion:last-child {
                            border-bottom: none;
                        }

                        .accordion-container {
                            width: 100%;
                        }

                        .accordion-heading {
                            margin: 0;
                            font: inherit;
                            font-weight: inherit;
                        }

                        .accordion-header {
                            width: 100%;
                            padding: 16px 0;
                            border: none;
                            background: none;
                            cursor: pointer;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            font-size: 16px;
                            font-weight: 500;
                            color: #333;
                            outline: none;
                            transition: color 0.2s ease;
                            font-family: Inter;
                            font-size: var(--Text-Sizes-Text-Regular, 16px);
                            font-style: normal;
                            font-weight: 400;
                            line-height: var(--Text-Sizes-weight-Regular, 32px); /* 200% */
                        }

                        .accordion-header:hover {
                            color: #555;
                        }

                        .accordion-header:focus {
                            outline: none;
                        }

                        .accordion-title {
                            text-align: left;
                            flex-grow: 1;
                        }

                        .accordion-arrow {
                            transition: transform 0.3s ease;
                            color: #666;
                            flex-shrink: 0;
                        }

                        .accordion-header[aria-expanded="true"] .accordion-arrow {
                            transform: rotate(180deg);
                        }

                        .accordion-content {
                            overflow: hidden;
                            max-height: 0;
                            transition: max-height 0.3s ease-in-out;
                        }

                        .accordion-content.open {
                            max-height: 1000px; /* Large enough value for content */
                        }

                        .accordion-inner {
                            padding-bottom: 16px;
                        }
                    `;
      document.head.appendChild(style);
    }
  }

  setupEventListeners() {
    const header = this.querySelector('.accordion-header');
    const content = this.querySelector('.accordion-content');

    header.addEventListener('click', () => {
      this.isOpen = !this.isOpen;

      if (this.isOpen) {
        content.classList.add('open');
        header.setAttribute('aria-expanded', 'true');

        // Calculate actual height for smoother animation
        const inner = this.querySelector('.accordion-inner');
        const height = inner.scrollHeight + 16; // +16 for bottom padding
        content.style.maxHeight = height + 'px';
      } else {
        content.classList.remove('open');
        header.setAttribute('aria-expanded', 'false');
        content.style.maxHeight = '0px';
      }
    });
  }
}

customElements.define('custom-accordion', CustomAccordion);

class FullScreenModal extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
    this.setupModal();
  }

  setupModal() {
    this.backdrop = document.createElement('div');
    this.backdrop.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.8);
      z-index: 9998;
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.3s ease, visibility 0.3s ease;
    `;

    this.modalContainer = document.createElement('div');
    this.modalContainer.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: white;
      z-index: 9999;
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.3s ease, visibility 0.3s ease, transform 0.3s ease;
      transform: scale(0.95);
      overflow-y: auto;
      display: flex;
      flex-direction: column;
    `;

    this.closeButton = document.createElement('button');
    this.closeButton.innerHTML = `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    `;
    this.closeButton.style.cssText = `
      position: absolute;
      top: 24px;
      right: 24px;
      background: rgba(255, 255, 255, 0.9);
      border: none;
      border-radius: 50%;
      width: 40px;
      height: 40px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      transition: background 0.2s ease;
      z-index: 10000;
    `;

    this.contentWrapper = document.createElement('div');
    this.contentWrapper.style.cssText = `
      padding: 80px 40px 40px 40px;
      flex: 1;
      width: 100%;
      max-width: 100%;
      margin: 0 auto;
    `;

    while (this.firstChild) {
      this.contentWrapper.appendChild(this.firstChild);
    }

    // Assemble modal
    this.modalContainer.appendChild(this.closeButton);
    this.modalContainer.appendChild(this.contentWrapper);

    document.body.appendChild(this.backdrop);
    document.body.appendChild(this.modalContainer);

    this.backdrop.addEventListener('click', () => this.close());
    this.closeButton.addEventListener('click', () => this.close());
    
    this.closeButton.addEventListener('mouseenter', () => {
      this.closeButton.style.background = 'rgba(255, 255, 255, 1)';
    });
    this.closeButton.addEventListener('mouseleave', () => {
      this.closeButton.style.background = 'rgba(255, 255, 255, 0.9)';
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.close();
      }
    });

    window.addEventListener('resize', () => this.updateStyles());
    this.updateStyles();
  }

  updateStyles() {
    const isMobile = window.innerWidth < 768;
    
    this.contentWrapper.style.padding = isMobile 
      ? '80px 20px 40px 20px' 
      : '80px 40px 40px 40px';
    
    this.closeButton.style.top = isMobile ? '16px' : '24px';
    this.closeButton.style.right = isMobile ? '16px' : '24px';
  }

  open() {
    if (this.isOpen) return;

    this.isOpen = true;
    document.body.style.overflow = 'hidden';

    this.backdrop.style.visibility = 'visible';
    this.backdrop.style.opacity = '1';

    this.modalContainer.style.visibility = 'visible';
    this.modalContainer.style.opacity = '1';
    this.modalContainer.style.transform = 'scale(1)';

    this.dispatchEvent(new CustomEvent('modal-opened'));
  }

  close() {
    if (!this.isOpen) return;

    this.isOpen = false;
    document.body.style.overflow = '';

    this.backdrop.style.opacity = '0';
    this.backdrop.style.visibility = 'hidden';

    this.modalContainer.style.opacity = '0';
    this.modalContainer.style.transform = 'scale(0.95)';
    this.modalContainer.style.visibility = 'hidden';

    this.dispatchEvent(new CustomEvent('modal-closed'));
  }

  toggle() {
    this.isOpen ? this.close() : this.open();
  }

  disconnectedCallback() {
    try {
      if (this.backdrop) {
        document.body.removeChild(this.backdrop);
      }
    } catch (e) {

    }

    try {
      if (this.modalContainer) {
        document.body.removeChild(this.modalContainer);
      }
    } catch (e) {

    }

    document.body.style.overflow = '';
  }
}

customElements.define('full-screen-modal', FullScreenModal);

class AccordionCard {
    constructor(config = {}) {
        // Default configuration
        this.config = {
            label: config.label || 'WORKOUT',
            title: config.title || 'Weighted Glute Kicks',
            description: config.description || '',
            imageUrl: config.imageUrl || null,
            imageClass: config.imageClass || '',
            onToggle: config.onToggle || null, // Callback function
            autoClose: config.autoClose !== false, // Auto close other cards (default: true)
        };
        
        this.element = null;
        this.isActive = false;
        this.wrapper = null;
        
        // Inject styles when first card is created
        this.injectStyles();
    }
    
    // Inject required CSS styles
    injectStyles() {
        if (!document.getElementById('accordion-card-styles')) {
            const styleSheet = document.createElement('style');
            styleSheet.id = 'accordion-card-styles';
            styleSheet.textContent = `
                .accordion-card {
                    background: white;
                    border: 1px solid #e0e0e0;
                    border-radius: 12px;
                    overflow: hidden;
                    cursor: pointer;
                    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
                }

                .accordion-card.active {
                    border-color: #000;
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
                }

                .accordion-card .card-content {
                    display: flex;
                    align-items: center;
                    padding: 12px;
                    position: relative;
                    min-height: 80px;
                }

                .accordion-card.active .card-content {
                    flex-direction: column;
                    align-items: flex-start;
                    padding: 16px;
                }

                .accordion-card .image-wrapper {
                    width: 60px;
                    height: 60px;
                    flex-shrink: 0;
                    position: relative;
                    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
                    transform-origin: center;
                }

                .accordion-card.active .image-wrapper {
                    width: 100%;
                    height: 180px;
                    margin-bottom: 12px;
                }

                .accordion-card .product-image {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    border-radius: 8px;
                    background: #f0f0f0;
                }

                .accordion-card .text-content {
                    flex: 1;
                    padding-left: 12px;
                    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
                }

                .accordion-card.active .text-content {
                    padding-left: 0;
                    width: 100%;
                }

                .accordion-card .product-label {
                    font-size: 10px;
                    text-transform: uppercase;
                    color: #666;
                    letter-spacing: 0.5px;
                    margin-bottom: 2px;
                    transition: all 0.3s ease;
                }

                .accordion-card .product-title {
                    font-size: 15px;
                    font-weight: 500;
                    color: #000;
                    margin-bottom: 0;
                    transition: all 0.3s ease;
                }

                .accordion-card .product-description {
                    font-size: 13px;
                    color: #666;
                    line-height: 1.4;
                    margin-top: 8px;
                    max-height: 0;
                    overflow: hidden;
                    opacity: 0;
                    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
                }

                .accordion-card.active .product-description {
                    max-height: 100px;
                    opacity: 1;
                    margin-top: 8px;
                }
            `;
            document.head.appendChild(styleSheet);
        }
    }

    // Create the card HTML element
    createCard() {
        const card = document.createElement('div');
        card.className = 'accordion-card';
        
        const cardContent = document.createElement('div');
        cardContent.className = 'card-content';
        
        // Create image wrapper
        const imageWrapper = document.createElement('div');
        imageWrapper.className = 'image-wrapper';
        
        if (this.config.imageUrl) {
            const img = document.createElement('img');
            img.src = this.config.imageUrl;
            img.className = 'product-image';
            img.alt = this.config.title;
            imageWrapper.appendChild(img);
        } else {
            const imgDiv = document.createElement('div');
            imgDiv.className = `product-image ${this.config.imageClass}`;
            imageWrapper.appendChild(imgDiv);
        }
        
        // Create text content
        const textContent = document.createElement('div');
        textContent.className = 'text-content';
        
        const label = document.createElement('div');
        label.className = 'product-label';
        label.textContent = this.config.label;
        
        const title = document.createElement('div');
        title.className = 'product-title';
        title.textContent = this.config.title;
        
        const description = document.createElement('div');
        description.className = 'product-description';
        description.textContent = this.config.description;
        
        // Assemble the card
        textContent.appendChild(label);
        textContent.appendChild(title);
        textContent.appendChild(description);
        
        cardContent.appendChild(imageWrapper);
        cardContent.appendChild(textContent);
        card.appendChild(cardContent);
        
        // Add click event
        card.addEventListener('click', () => this.toggle());
        
        this.element = card;
        return card;
    }

    // Toggle card state
    toggle() {
        const wasActive = this.isActive;
        
        if (this.config.autoClose && this.wrapper) {
            // Close all other cards in the same wrapper
            const allCards = this.wrapper.querySelectorAll('.accordion-card');
            allCards.forEach(card => {
                if (card !== this.element) {
                    card.classList.remove('active');
                    // Update the isActive state for other cards in the same wrapper
                    // Find the card instance and update its state
                    const cardInstance = this.findCardInstance(card);
                    if (cardInstance) {
                        cardInstance.isActive = false;
                    }
                }
            });
        }
        
        // Toggle this card - if it wasn't active, make it active; if it was active, close it
        this.isActive = !wasActive;
        if (this.isActive) {
            this.element.classList.add('active');
        } else {
            this.element.classList.remove('active');
        }
        
        // Call callback if provided
        if (this.config.onToggle) {
            this.config.onToggle(this.isActive, this);
        }
    }
    
    // Helper method to find card instance from element
    findCardInstance(element) {
        // This will be overridden when attached to wrapper
        return null;
    }

    // Programmatically set active state
    setActive(active) {
        this.isActive = active;
        if (this.element) {
            if (active) {
                this.element.classList.add('active');
            } else {
                this.element.classList.remove('active');
            }
        }
    }

    // Update card content
    updateContent(updates) {
        if (updates.label) {
            this.config.label = updates.label;
            if (this.element) {
                this.element.querySelector('.product-label').textContent = updates.label;
            }
        }
        
        if (updates.title) {
            this.config.title = updates.title;
            if (this.element) {
                this.element.querySelector('.product-title').textContent = updates.title;
            }
        }
        
        if (updates.description) {
            this.config.description = updates.description;
            if (this.element) {
                this.element.querySelector('.product-description').textContent = updates.description;
            }
        }
        
        if (updates.imageUrl && this.element) {
            const imageWrapper = this.element.querySelector('.image-wrapper');
            imageWrapper.innerHTML = '';
            const img = document.createElement('img');
            img.src = updates.imageUrl;
            img.className = 'product-image';
            img.alt = this.config.title;
            imageWrapper.appendChild(img);
            this.config.imageUrl = updates.imageUrl;
        }
    }

    // Attach to a wrapper (for auto-close functionality)
    attachToWrapper(wrapper) {
        this.wrapper = wrapper;
    }

    // Destroy the card
    destroy() {
        if (this.element && this.element.parentNode) {
            this.element.parentNode.removeChild(this.element);
        }
        this.element = null;
        this.wrapper = null;
    }
}
class AccordionImageCard {
    constructor(config = {}) {
        // Default configuration
        this.config = {
            label: config.label || 'WORKOUT',
            title: config.title || 'Weighted Glute Kicks',
            description: config.description || '',
            imageUrl: config.imageUrl || null,
            imageClass: config.imageClass || '',
            onToggle: config.onToggle || null, // Callback function
            autoClose: config.autoClose !== false, // Auto close other cards (default: true)
        };
        
        this.element = null;
        this.isActive = false;
        this.wrapper = null;
        
        // Inject styles when first card is created
        this.injectStyles();
    }
    
    // Inject required CSS styles
    injectStyles() {
        if (!document.getElementById('accordion-card-styles')) {
            const styleSheet = document.createElement('style');
            styleSheet.id = 'accordion-card-styles';
            styleSheet.textContent = `
                .accordion-card {
                    background: white;
                    border: 1px solid #e0e0e0;
                    border-radius: 12px;
                    overflow: hidden;
                    cursor: pointer;
                    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
                }

                .accordion-card.active {
                    border-color: #000;
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
                }

                .accordion-card .card-content {
                    display: flex;
                    align-items: center;
                    padding: 12px;
                    position: relative;
                    min-height: 80px;
                }

                .accordion-card.active .card-content {
                    flex-direction: column;
                    align-items: flex-start;
                    padding: 16px;
                }

                .accordion-card .image-wrapper {
                    width: 60px;
                    height: 60px;
                    flex-shrink: 0;
                    position: relative;
                    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
                    transform-origin: center;
                }

                .accordion-card.active .image-wrapper {
                    width: 100%;
                    height: 180px;
                    margin-bottom: 12px;
                }

                .accordion-card .product-image {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    border-radius: 8px;
                    background: #f0f0f0;
                }

                .accordion-card .text-content {
                    flex: 1;
                    padding-left: 12px;
                    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
                }

                .accordion-card.active .text-content {
                    padding-left: 0;
                    width: 100%;
                }

                .accordion-card .product-label {
                    font-size: 10px;
                    text-transform: uppercase;
                    color: #666;
                    letter-spacing: 0.5px;
                    margin-bottom: 2px;
                    transition: all 0.3s ease;
                }

                .accordion-card .product-title {
                    font-size: 15px;
                    font-weight: 500;
                    color: #000;
                    margin-bottom: 0;
                    transition: all 0.3s ease;
                }

                .accordion-card .product-description {
                    font-size: 13px;
                    color: #666;
                    line-height: 1.4;
                    margin-top: 8px;
                    max-height: 0;
                    overflow: hidden;
                    opacity: 0;
                    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
                }

                .accordion-card.active .product-description {
                    max-height: 100px;
                    opacity: 1;
                    margin-top: 8px;
                }
            `;
            document.head.appendChild(styleSheet);
        }
    }

    // Create the card HTML element
    createCard() {
        const card = document.createElement('div');
        card.className = 'accordion-card';
        
        const cardContent = document.createElement('div');
        cardContent.className = 'card-content';
        
        // Create image wrapper
        const imageWrapper = document.createElement('div');
        imageWrapper.className = 'image-wrapper';
        
        if (this.config.imageUrl) {
            const img = document.createElement('img');
            img.src = this.config.imageUrl;
            img.className = 'product-image';
            img.alt = this.config.title;
            imageWrapper.appendChild(img);
        } else {
            const imgDiv = document.createElement('div');
            imgDiv.className = `product-image ${this.config.imageClass}`;
            imageWrapper.appendChild(imgDiv);
        }
        
        // Create text content
        const textContent = document.createElement('div');
        textContent.className = 'text-content';
        
        const label = document.createElement('div');
        label.className = 'product-label';
        label.textContent = this.config.label;
        
        const title = document.createElement('div');
        title.className = 'product-title';
        title.textContent = this.config.title;
        
        const description = document.createElement('div');
        description.className = 'product-description';
        description.textContent = this.config.description;
        
        // Assemble the card
        textContent.appendChild(label);
        textContent.appendChild(title);
        textContent.appendChild(description);
        
        cardContent.appendChild(imageWrapper);
        cardContent.appendChild(textContent);
        card.appendChild(cardContent);
        
        // Add click event
        card.addEventListener('click', () => this.toggle());
        
        this.element = card;
        return card;
    }

    // Toggle card state
    toggle() {
        const wasActive = this.isActive;
        
        if (this.config.autoClose && this.wrapper) {
            // Close all other cards in the same wrapper
            const allCards = this.wrapper.querySelectorAll('.accordion-card');
            allCards.forEach(card => {
                if (card !== this.element) {
                    card.classList.remove('active');
                    // Update the isActive state for other cards in the same wrapper
                    // Find the card instance and update its state
                    const cardInstance = this.findCardInstance(card);
                    if (cardInstance) {
                        cardInstance.isActive = false;
                    }
                }
            });
        }
        
        // Toggle this card - if it wasn't active, make it active; if it was active, close it
        this.isActive = !wasActive;
        if (this.isActive) {
            this.element.classList.add('active');
        } else {
            this.element.classList.remove('active');
        }
        
        // Call callback if provided
        if (this.config.onToggle) {
            this.config.onToggle(this.isActive, this);
        }
    }
    
    // Helper method to find card instance from element
    findCardInstance(element) {
        // This will be overridden when attached to wrapper
        return null;
    }

    // Programmatically set active state
    setActive(active) {
        this.isActive = active;
        if (this.element) {
            if (active) {
                this.element.classList.add('active');
            } else {
                this.element.classList.remove('active');
            }
        }
    }

    // Update card content
    updateContent(updates) {
        if (updates.label) {
            this.config.label = updates.label;
            if (this.element) {
                this.element.querySelector('.product-label').textContent = updates.label;
            }
        }
        
        if (updates.title) {
            this.config.title = updates.title;
            if (this.element) {
                this.element.querySelector('.product-title').textContent = updates.title;
            }
        }
        
        if (updates.description) {
            this.config.description = updates.description;
            if (this.element) {
                this.element.querySelector('.product-description').textContent = updates.description;
            }
        }
        
        if (updates.imageUrl && this.element) {
            const imageWrapper = this.element.querySelector('.image-wrapper');
            imageWrapper.innerHTML = '';
            const img = document.createElement('img');
            img.src = updates.imageUrl;
            img.className = 'product-image';
            img.alt = this.config.title;
            imageWrapper.appendChild(img);
            this.config.imageUrl = updates.imageUrl;
        }
    }

    // Attach to a wrapper (for auto-close functionality)
    attachToWrapper(wrapper) {
        this.wrapper = wrapper;
    }

    // Destroy the card
    destroy() {
        if (this.element && this.element.parentNode) {
            this.element.parentNode.removeChild(this.element);
        }
        this.element = null;
        this.wrapper = null;
    }
}

// AccordionWrapper class to manage multiple cards
class AccordionWrapper {
    constructor(containerId, options = {}) {
        this.container = document.getElementById(containerId);
        this.cards = [];
        this.options = {
            gap: options.gap || '12px',
            maxWidth: options.maxWidth || '400px',
            ...options
        };
        
        if (this.container) {
            this.setupContainer();
        }
    }

    setupContainer() {
        this.container.style.display = 'flex';
        this.container.style.flexDirection = 'column';
        this.container.style.gap = this.options.gap;
        if (this.options.maxWidth) {
            this.container.style.maxWidth = this.options.maxWidth;
        }
    }

    addCard(cardConfig) {
        const card = new AccordionCard(cardConfig);
        card.attachToWrapper(this.container);
        
        // Override the findCardInstance method to work with this wrapper
        card.findCardInstance = (element) => {
            return this.cards.find(c => c.element === element);
        };
        
        // Override the toggle method for better control
        const originalToggle = card.toggle.bind(card);
        card.toggle = () => {
            const wasActive = card.isActive;
            
            // Close all other cards
            this.cards.forEach(c => {
                if (c !== card && c.isActive) {
                    c.setActive(false);
                }
            });
            
            // Set this card's state - always open if it was closed, close if it was open
            card.setActive(!wasActive);
            
            // Call callback if provided
            if (card.config.onToggle) {
                card.config.onToggle(card.isActive, card);
            }
        };
        
        const cardElement = card.createCard();
        this.container.appendChild(cardElement);
        this.cards.push(card);
        return card;
    }

    addCards(cardsData) {
        cardsData.forEach(data => this.addCard(data));
    }

    removeCard(card) {
        const index = this.cards.indexOf(card);
        if (index > -1) {
            this.cards.splice(index, 1);
            card.destroy();
        }
    }

    clearAll() {
        this.cards.forEach(card => card.destroy());
        this.cards = [];
        this.container.innerHTML = '';
    }

    closeAll() {
        this.cards.forEach(card => card.setActive(false));
    }

    getActiveCard() {
        return this.cards.find(card => card.isActive);
    }
}
customElements.define('accordion-card-wrapper', AccordionWrapper);
customElements.define('accordion-card', AccordionImageCard);

/**
 * Product card swatch interaction (snippets/product-card-swatch.liquid).
 * Delegated on document so it works wherever the card is rendered, without
 * each section having to reimplement hover/click/pin/keyboard handling.
 */
(function () {
  function activateSwatch(card, color) {
    card.querySelectorAll('.pcs-card__img[data-color]').forEach(function (img) {
      img.classList.toggle('pcs-card__img--active', img.dataset.color === color);
    });
    card.querySelectorAll('.pcs-swatch[data-color]').forEach(function (s) {
      s.classList.toggle('pcs-swatch--active', s.dataset.color === color);
    });
  }

  function defaultColor(card) {
    var first = card.querySelector('.pcs-swatch[data-color]');
    return first ? first.dataset.color : null;
  }

  var isDesktop = window.matchMedia('(min-width: 750px)');

  // Hover — desktop only, only when no swatch is pinned
  document.addEventListener('mouseover', function (e) {
    if (!isDesktop.matches) return;
    var swatch = e.target.closest('.pcs-swatch[data-color]');
    if (!swatch) return;
    var card = swatch.closest('[data-pcs-card]');
    if (!card || card.hasAttribute('data-swatch-pinned')) return;
    activateSwatch(card, swatch.dataset.color);
  });

  document.addEventListener('mouseout', function (e) {
    if (!isDesktop.matches) return;
    var swatch = e.target.closest('.pcs-swatch[data-color]');
    if (!swatch) return;
    // Only revert if we're not moving to another swatch on the same card
    var dest = e.relatedTarget && e.relatedTarget.closest('.pcs-swatch[data-color]');
    var card = swatch.closest('[data-pcs-card]');
    if (!card || card.hasAttribute('data-swatch-pinned')) return;
    if (dest && dest.closest('[data-pcs-card]') === card) return;
    var def = defaultColor(card);
    if (def) activateSwatch(card, def);
  });

  // Click — pin/unpin; prevent card navigation
  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('.pcs-swatch[data-color]');
    if (!swatch) return;
    e.preventDefault(); // prevents <a> navigation
    var card = swatch.closest('[data-pcs-card]');
    if (!card) return;
    var color = swatch.dataset.color;
    var pinned = card.getAttribute('data-swatch-pinned');
    if (pinned === color) {
      // Clicking pinned swatch again: unpin and revert to default
      card.removeAttribute('data-swatch-pinned');
      var def = defaultColor(card);
      if (def) activateSwatch(card, def);
    } else {
      card.setAttribute('data-swatch-pinned', color);
      activateSwatch(card, color);
    }
  });

  // Keyboard accessibility for swatches
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var swatch = e.target.closest('.pcs-swatch[data-color]');
    if (!swatch) return;
    e.preventDefault();
    var card = swatch.closest('[data-pcs-card]');
    if (!card) return;
    var color = swatch.dataset.color;
    card.setAttribute('data-swatch-pinned', color);
    activateSwatch(card, color);
  });
})();
